export const forceTerminl = [
  { label: "Midnight", value: "Midnight" },
  { label: "After 24hrs", value: "After 24hrs" },
];
export const statusData = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

export const TaskStatus = [
  { label: "New task", value: "New Task" },
  { label: "In Progress", value: "In Progress" },
  { label: "Completed", value: "Completed" },
];

export const TaskStatusDsr = [
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
  { label: "Pending", value: "Pending" },
];

export const TaskStatusOptions = ["New Task", "In Progress", "Completed"];

export const TaskStatusDsrOptions = ["Approved", "Rejected"];

export const ProjectStatus = [
  { label: "Ongoing", value: "Ongoing" },
  { label: "Closed", value: "Closed" },
];

export const ReportStatus = [
  { label: "Approved", value: true },
  { label: "Pending", value: false },
];
export const userRoles = [
  { label: "Admin ", value: "Admin " },
  { label: "Manager", value: "Manager" },
  { label: "Viewer", value: "Viewer" },
];

export const Priorities = [
  { label: "Low ", value: "Low" },
  { label: "Medium", value: "Medium" },
  { label: "High", value: "High" },
  { label: "Critical", value: "Critical" },
];

export const TaskType = [
  { label: "User Story", value: "User Story" },
  { label: "Task", value: "Task" },
  { label: "Bug", value: "Bug" },
];

export const businessTypes = [
  { value: "Private Limited", label: "Private Limited" },
  { value: "Public Limited", label: "Public Limited" },
  { value: "Sole Proprietorship", label: "Sole Proprietorship" },
  { value: "Individual", label: "Individual" },
  { value: "Partnership", label: "Partnership" },
  { value: "Limited Liability Company", label: "Limited Liability Company" },
  {
    value: "Limited Liability Partnership",
    label: "Limited Liability Partnership",
  },
  { value: "Corporation", label: "Corporation" },
  {
    value: "Non-Government Organization",
    label: "Non-Government Organization",
  },
];

export const frequencyOptions = [
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "yearly", label: "Yearly" },
  { value: "working_days", label: "Working Days" },
];
